import * as React from 'react';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@grandvisionhq/state';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import { ProductDetailCTA } from '../../../components/CTAs/ProductDetailCTA/ProductDetailCTA.js';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useSunglassesEcommContext } from '../../context/SunglassesEcommContext.js';

const SunglassesCTA = ()=>{
    const { activeVariant: { sku  } ,  } = useProductData();
    const { productAction , handleConfiguratorOpen  } = useSunglassesEcommContext();
    const handleConversionEvent = React.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const onAddToCartSuccess = React.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    return /*#__PURE__*/ React.createElement(ProductDetailCTA, {
        action: productAction,
        handleConfiguratorOpen: handleConfiguratorOpen,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku: sku,
            onSuccess: onAddToCartSuccess
        }
    });
};

export { SunglassesCTA };
//# sourceMappingURL=SunglassesCTA.js.map
